export const EMAIL_STATUS_BADGES = {
    WAITING: 'text-bg-info',
    QUEUED: 'text-bg-secondary',
    RESEND: 'text-bg-warning',
    SENT: 'text-bg-success',
    FAILED: 'text-bg-danger',
};

export const SMS_STATUS_BADGES = {
    WAITING: 'text-bg-info',
    RESEND: 'text-bg-warning',
    ACCEPTED: 'text-bg-primary',
    QUEUED: 'text-bg-secondary',
    SENT: 'text-bg-success',
    FAILED: 'text-bg-danger',
    DELIVERED: 'text-bg-success',
    UNDELIVERED: 'text-bg-warning',
    ERROR: 'text-bg-danger',
    REJECTED: 'text-bg-dark',
};

const EMAIL_RESENDABLE_STATUSES = new Set(['WAITING', 'FAILED', 'SENT', 'RESEND']);
const SMS_RESENDABLE_STATUSES = new Set([
    'WAITING',
    'FAILED',
    'UNDELIVERED',
    'ERROR',
    'REJECTED',
    'SENT',
    'RESEND',
]);

export const canResendEmailQueue = (status) => EMAIL_RESENDABLE_STATUSES.has(status);
export const canResendSmsQueue = (status) => SMS_RESENDABLE_STATUSES.has(status);

export const RECALL_STATUS_BADGES = {
    PENDING: 'text-bg-secondary',
    IN_PROCESS: 'text-bg-primary',
    COMPLETED: 'text-bg-success',
    FAILED: 'text-bg-danger',
};

export const formatScheduledSend = (dateSend, timeSend) => {
    if (!dateSend && !timeSend) return '—';
    return [dateSend, timeSend].filter(Boolean).join(' ');
};

export const formatStatusLabel = (status) => {
    if (!status) return 'Unknown';
    return status
        .split('_')
        .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
        .join(' ');
};

export const getShortId = (id) => {
    if (!id) return '—';
    const idStr = String(id);
    return idStr.length > 12 ? '…' + idStr.slice(-12) : idStr;
};

export const toProperCase = (inputString) => {
    if (!inputString) return '—';
    return inputString
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
};

export const formatExtraInfo = (extraInfo) => {
    if (extraInfo == null) return '—';
    if (typeof extraInfo === 'object') {
        try {
            return JSON.stringify(extraInfo, null, 2);
        } catch {
            return String(extraInfo);
        }
    }
    return String(extraInfo);
};

export const truncateText = (text, max = 48) => {
    if (!text) return '—';
    return text.length > max ? text.slice(0, max) + '…' : text;
};
